import { createContext, useContext } from 'react'

export const EmbedContext = createContext(false)

export const useInEmbed = () => useContext(EmbedContext)
